import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.lizenz-mandant-options';
import * as api from '../../../clients/api';

@Injectable()
export class ApiLizenzMandantOptionsEffects {

    LizenzMandantOptions$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_LIZENZ_MANDANT_OPTIONS),
        mergeMap((x: ac.GetLizenzMandantOptionsAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getLizenzMandantOptions().pipe(
                map((result: any) => {
                    return new ac.GetLizenzMandantOptionsErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetLizenzMandantOptionsFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.MandantenTemplatesService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.MandantenTemplatesService {
        if (this.service === null) {
            this.service = this.injector.get(api.MandantenTemplatesService);
        }
        return this.service;
    }
}
